import * as React from 'react';
import styled from 'styled-components';
import { colors, fontSizes } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const StyledRadioButton = styled.div<{ isChecked: boolean; name?: string; value?: string }>`
  align-items: center;
  background-color: ${({ isChecked }) => (isChecked ? colors.purple10 : '#fcfcfc')};
  border: ${pxToRem(1)} solid;
  border-color: ${({ isChecked }) => (isChecked ? colors.purple50 : '#d6d6d6')};
  cursor: pointer;
  display: flex;
  font-size: ${fontSizes.s16};
  height: ${pxToRem(120)};
  justify-content: center;
  outline: ${pxToRem(1)} solid;
  outline-color: ${({ isChecked }) => (isChecked ? colors.purple50 : '#d6d6d6')};
  position: relative;
  z-index: ${({ isChecked }) => (isChecked ? 2 : 1)};
  &:focus,
  &:hover {
    background-color: ${colors.purple10};
  }
`;

type Props = {
  /** unique id for the radio button */
  id: string;
  /** Whether the command or control is checked */
  isChecked: boolean;
  /** Hashtag: the content */
  children: React.ReactNode;
  /** Name of the input form control. Submitted with the form as part of a name/value pair. */
  name: string;
  /** Function ran when the input is clicked */
  onClick: () => void;
};

export const RadioGroupButton = ({ id, isChecked, name, children, onClick, ...props }: Props) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    e.stopPropagation();
    if (e.key === 'Enter') {
      onClick();
    }
  };

  return (
    <StyledRadioButton
      aria-checked={isChecked ? 'true' : 'false'}
      data-test={`radio-group-button-${id}`}
      isChecked={isChecked}
      id={id}
      name={name}
      onClick={onClick}
      onKeyDown={handleKeyPress}
      role="radio"
      tabIndex={0}
      {...props}
    >
      {children}
    </StyledRadioButton>
  );
};
